<template>
  <a-radio-group v-model:value="model">
    <slot></slot>
  </a-radio-group>
</template>

<script setup>
  import { defineModel } from 'vue';

  const model = defineModel();
</script>

<style lang="scss" scoped>

</style>